import { useState } from "react";
import dynamic from "next/dynamic";
import { useTranslation } from "next-i18next";

const FooterPayments = dynamic(() => import("./FooterPayments"));
const UsefulLinks = dynamic(() => import("./UsefulLinks"));
const QuickLinks = dynamic(() => import("./QuickLinks"));
const NewsLetter = dynamic(() => import("./NewsLetter"));
const FooterApps = dynamic(() => import("./FooterApps"));
const Categories = dynamic(() => import("./Categories"));
const ContactUs = dynamic(() => import("./ContactUs"));
const AboutUs = dynamic(() => import("./AboutUs"));

const Footer = () => {
  const [active, setActive] = useState(false);
  const { t } = useTranslation("common");

  return (
    <footer className="w-full">
      <NewsLetter />
      <div className="divide-y-[1px] divide-gray-50/15">
        <div className="bg-[#231F20] text-white py-4 md:pt-10">
          <FooterApps t={t} />
          <div className="grid w-11/12 grid-cols-12 gap-6 mx-auto md:gap-12 max-sm:text-xs">
            <AboutUs {...{ t, active, setActive }} />
            <Categories {...{ t, active, setActive }} />
            <UsefulLinks {...{ t, active, setActive }} />
            <QuickLinks {...{ t, active, setActive }} />
            <ContactUs {...{ t, active, setActive }} />
          </div>
          <FooterPayments />
        </div>
      </div>
      <div className="bg-[#231F20] pb-24 lg:pb-3">
        <p className="w-11/12 pt-4 pb-2 mx-auto text-xs text-center text-white border-t border-t-white md:border-t-tertiary-700 sm:text-base">
          &copy; {new Date().getFullYear()} {t("Copyright")}
        </p>
        <FooterPayments isResponsive />
      </div>
    </footer>
  );
};

export default Footer;
